import { darken, lighten } from '@material-ui/core/styles/colorManipulator';
import { COLORS } from 'src/constants/Color';

const palette = {
  primary: {
    main: COLORS.primary,
    light: lighten(COLORS.primary, 0.3),
    dark: darken(COLORS.primary, 0.3),
    contrastText: COLORS.white,
  },
  secondary: {
    main: COLORS.secondary,
    light: lighten(COLORS.secondary, 0.3),
    dark: darken(COLORS.secondary, 0.3),
    contrastText: COLORS.white,
  },
  action: {
    main: COLORS.action,
    light: lighten(COLORS.action, 0.3),
    dark: darken(COLORS.action, 0.3),
    contrastText: COLORS.white,
  },
  disabled: {
    main: COLORS.action,
    light: lighten(COLORS.action, 0.3),
    dark: darken(COLORS.action, 0.3),
    contrastText: COLORS.white,
  },
  warning: {
    main: COLORS.warning,
    light: lighten(COLORS.warning, 0.3),
    dark: darken(COLORS.warning, 0.3),
    contrastText: COLORS.white,
  },
  background: {
    paper: COLORS.white,
    default: COLORS.background,
  },
};

export default palette;
